import { render, staticRenderFns } from "./AuroraListInfo.vue?vue&type=template&id=5bf92a85"
import script from "./AuroraListInfo.vue?vue&type=script&lang=js"
export * from "./AuroraListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports